module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Generator-7ef00c3d72f9ce3fe138d52c5beafb30.svg";